import * as React from 'react';
import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ConsultantChatPopup.css';

interface IConsultantChatPopupProps {
  url?: string;
  onClose(): void;
}

export const ConsultantChatPopup: React.FC<IConsultantChatPopupProps> = ({ url, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  return (
    <div className={styles['container']} data-testid="ConsultantCianChatPopup">
      <span className={styles['close']}>
        <IconButton icon={<IconActionClose16 />} data-testid="ConsultantChatCloseButton" onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      {url && <iframe className={styles['iframe']} src={url} onLoad={onLoad} onError={onLoad} />}
    </div>
  );
};
